import React from 'react';

import { PrimaryNavView } from '@futrli/views/views/nav/PrimaryNavView/PrimaryNavView';

import { DesktopNavBarScaffold } from '../../components/desktop/desktop-nav-scaffold/desktop-nav-scaffold';
import { HelpMenu } from '../../components/desktop/help-menu/help-menu';
import { OrganisationsMenu } from '../../components/desktop/organisations-menu/organisations-menu';
import { ProfileMenu } from '../../components/desktop/profile-menu/profile-menu';

import styles from './primary-nav-desktop.scss';

export const PrimaryNavDesktop = ({ view }: { view: PrimaryNavView }) => {
  const { consolidations, flags, userName, workspace } = view.state;

  return (
    <DesktopNavBarScaffold
      customClassName={`${styles.flexOneThird} ${styles.fullHeight}`}
      main={
        workspace && (
          <OrganisationsMenu
            hasMembersPermission={flags.hasMembersPermission}
            organisations={[...workspace.organisations, ...consolidations]}
          />
        )
      }
      right={
        <div className={styles.inner}>
          <ProfileMenu userName={userName} showMyProfile={flags.showMyProfile} />
          <HelpMenu />
        </div>
      }
    />
  );
};
